import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { MatTableDataSource, MatPaginator, MAT_DIALOG_DATA, MatDialog, MatDatepickerInputEvent, MatDialogRef } from '@angular/material';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from 'src/app/service/api.service';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import * as _moment from 'moment';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { numValidation } from 'src/app/service/customValidation';
import { Select2OptionData } from 'ng-select2';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged, tap, switchMap, map } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { environment } from 'src/environments/environment.prod';
import { DataPassingService } from 'src/app/service/data-passing.service';
import { ExcelService } from 'src/app/service/excel.service';

const moment = _moment;

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export interface StandardElement {
  name: string;
  dueAmount: string;
}


@Component({
  selector: 'app-donar-list',
  templateUrl: './donar-list.component.html',
  styleUrls: ['./donar-list.component.css'],
  providers:[
    {provide:DateAdapter,useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE]},
    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ]
})
export class DonarListComponent implements OnInit {
  maxValid=false;
  maxDate=new Date();
  displayedColumns: string[] = ['name','dueDate','loanAmount','paidAmount','remainAmount','action'];
  dataSource:MatTableDataSource<any>=new MatTableDataSource();
  @ViewChild(MatPaginator) paginator: MatPaginator;
  dataTable: any;
  tblLoading=false;
  itemTotal=0;
  studList=true;
  isForm=false;
  isReceipt=false;
  isSubmitted=false;
  isSuccess=false;
  isError=false;
  message='';
  inputFormGroup:FormGroup;
  selectFormGroup:FormGroup;
  isGreater=false;
  isDisabled=false;
  searching = false;
  searchFailed = false;
  returnData:any=[];
  fund='';
  name='';
  srNo=0;
  paymentModeList:Array<Select2OptionData>;
  totals:any;
  public donarType: Array<Select2OptionData>;
  constructor(private router:Router,private excelService:ExcelService,private formBuilder:FormBuilder,private api:ApiService,private route:ActivatedRoute,private datePipe:DatePipe,private dataPass:DataPassingService,public dialog: MatDialog) {
    this.inputFormGroup=this.formBuilder.group({
      id:[''],
      name:[''],
      dueDate:[''],
      paidAmount:['',[Validators.required,numValidation()]],
      paymentMode:['',Validators.required],
      reference:[''],
      bank:[''],
      remaining:[''],
      donate:[''],
      providerId:[''],
      paymentText:['']
    });
    this.selectFormGroup=this.formBuilder.group({
      fundType:['']
    });
   }

  ngOnInit() {
    this.totals=[];
    this.totals.totalDonation=this.totals.totalPaid=this.totals.totalPending=0;
    this.donarType=[];
    this.route.data.subscribe(data=>{
      data.employee[1].data.forEach(element => {
        var bData={id:element.id,text:element.title};
        this.donarType.push(bData);
      });
    },(error)=>{

    });

    this.paymentModeList=[];
    this.route.data.subscribe(data=>{
      data.employee[2].data.forEach(element => {
        let aData={id:element.id,text:element.name};
        this.paymentModeList.push(aData);
      });
    },(error)=>{});

  }

  exportAsXLSX():void {
    this.api.get("donar?fundType="+this.fund+"&export=excel").subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      data.data.push({"Mobile":"Total","Donation":data.totals.totalDonation,"Paid":data.totals.totalPaid,"Pending":data.totals.totalPending});
      this.excelService.exportAsExcelFile(data.data, 'donar');
    },(error)=>{

    });
    
 }

 counter(i)
 {
   let num=i+1;
   return this.srNo+num;
 }

 fetchDonar(form)
 {
  this.fund=form.value.fundType;
  this.refreshTable(0,10,this.fund);
 }
 reset()
 {
   window.location.reload();
 }


 searchname(e)
 {
   let url='';
   if(e.target.value.length>1)
   {
    url="donar?fundType="+this.fund+"&orderBy=id_desc&start=0&length=10&name="+e.target.value;
   }
   else if(e.target.value.length==0)
   {
     url="donar?fundType="+this.fund+"&orderBy=id_desc&start=0&length=10";
   }

   this.api.get(url).subscribe(data=>{
    this.itemTotal=parseInt(data.total);
    this.dataSource.data=data.data;
    this.totals=data.totals;
  },(error)=>{

  });
    
 }

 checkValue()
  {
    
    let paidAmount=this.inputFormGroup.controls.paidAmount.value;
   
    if(parseInt(paidAmount)<=1)
    {
      this.isGreater=true;
      this.isDisabled=true;
    }
    else
    {
     this.isGreater=false;
     this.isDisabled=false;
    }

  }

 onPayment(id,name,amount,donateAmount,pid)
  {
    this.studList=false;
    this.isForm=true;
    this.inputFormGroup.patchValue({id:id,name:name,remaining:amount,donate:donateAmount,providerId:pid});
    
  }

  tblItmPageChange(event)
  {
    let start=(event.pageIndex>0)?(event.pageSize*event.pageIndex):event.pageIndex;
    this.srNo=start;
    this.refreshTable(start,event.pageSize,this.fund);
  }

  refreshTable(start,pageSize,fundType)
  {
    this.api.get("donar?fundType="+fundType+"&orderBy=id_desc&start="+start+"&length="+pageSize).subscribe(data=>{
      this.itemTotal=parseInt(data.total);
      this.dataSource.data=data.data;
      this.totals=data.totals;
    },(error)=>{

    });
  }

  onEdit(id)
  {
    this.dataPass.passDataService({id:id});
    this.router.navigateByUrl("/admin/donar");
  }
  onDelete(id)
  {
    const dialogRef = this.dialog.open(confirmDialog,{
      data: {
        id:id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
     // this.refreshTable(0,10,this.fund);
    });
   
  }

  

  dateTranform()
  {
    let dt=new Date();
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }

  onView(e,id)
  {
    e.preventDefault();
    const dialogRef = this.dialog.open(DialogDonar,{
      data: {
        id:id
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      
    });
  }

  receiptNo(no)
  {
    let num=no.toString();
    if(num.length<2)
    {
      return '00'+num;
    }
    else if(num.length<3)
    {
      return '0'+num;
    }
    else
    {
      return num;
    }

  }

  changePage(event)
  {
    event.preventDefault();
    this.isForm=!this.isForm;
    this.isReceipt=!this.isReceipt;
  }

 paymentMode(event)
 {
  for(var i=0;i<this.paymentModeList.length;i++)
  {
    if(this.paymentModeList[i].id==event)
    {
      this.inputFormGroup.patchValue({paymentText:this.paymentModeList[i].text});
     
    }
    
  }
  
 }

 print()
 {
   window.print();
 }

 saveForm(form)
 {
   this.returnData=[];
   this.isError=false;
   this.isSuccess=false;
   this.isDisabled=true;
   this.isSubmitted=true;
   if(this.inputFormGroup.invalid)
   {
     this.isDisabled=false;
     return false;
   }
   else
   {
     form.value.dueDate=(form.value.dueDate!="")?this.datePipe.transform(form.value.dueDate,"dd/MM/yyyy"):'';
     this.api.post(form.value,'transaction').subscribe(data=>{
       if(data.status)
       {
        /* this.api.get('totalDues').subscribe(rtotal=>{
             this.dataPass.passDataService({total:rtotal.total});
         },(error)=>{});*/
         this.isForm=!this.isForm;
         this.isReceipt=!this.isReceipt;
         this.returnData=data.details;
         this.returnData['name']=document.querySelector<HTMLInputElement>("#name").value;
         this.returnData['paymentText']=this.inputFormGroup.controls.paymentText.value;
        
       }
       else
       {
         this.isError=true;
         this.message=data.message;
       }

       this.isSubmitted=false;
       this.isDisabled=false;
       this.inputFormGroup.reset();
       document.querySelector<HTMLInputElement>("#name").value='';
     },(error)=>{});

   }
 }

 

  convertNumberToWords(num) {
    let n;
    var a = ['','One ','Two ','Three ','Four ', 'Five ','Six ','Seven ','Eight ','Nine ','Ten ','Eleven ','Twelve ','Thirteen ','Fourteen ','Fifteen ','Sixteen ','Seventeen ','Eighteen ','Nineteen '];
    var b = ['', '', 'Twenty','Thirty','Forty','Fifty', 'Sixty','Seventy','Eighty','Ninety'];
    if ((num = num.toString()).length > 9) return 'overflow';
    n = ('000000000' + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{1})(\d{2})$/);
    if (!n) return; var str = '';
    str += (n[1] != 0) ? (a[Number(n[1])] || b[n[1][0]] + ' ' + a[n[1][1]]) + 'Crore ' : '';
    str += (n[2] != 0) ? (a[Number(n[2])] || b[n[2][0]] + ' ' + a[n[2][1]]) + 'Lakh ' : '';
    str += (n[3] != 0) ? (a[Number(n[3])] || b[n[3][0]] + ' ' + a[n[3][1]]) + 'Thousand ' : '';
    str += (n[4] != 0) ? (a[Number(n[4])] || b[n[4][0]] + ' ' + a[n[4][1]]) + 'Hundred ' : '';
    str += (n[5] != 0) ? ((str != '') ? 'and ' : '') + (a[Number(n[5])] || b[n[5][0]] + ' ' + a[n[5][1]]) + 'only ' : '';
    return str;
  }

  dateEvent(type: string, event: MatDatepickerInputEvent<any>) {
    this.isDisabled=false;
    this.maxValid=false;
    let dt=event.value._d;
    let nwDt=new Date();
    if(dt>=nwDt)
    {
      this.isDisabled=true;
      this.maxValid=true;
     
      
    }
  }

}


@Component({
  selector: 'dialog-data-example-dialog',
  templateUrl:'./view-donar.html',
  styleUrls: ['./donar-list.component.css'],
})
export class DialogDonar {
  showLoading=true;
  constructor(private dataPass:DataPassingService,private api:ApiService,@Inject(MAT_DIALOG_DATA) public data: any,private datePipe:DatePipe) {
   this.api.get('donar?id='+data.id).subscribe(data=>{
     this.data=data.data[0];
         this.showLoading=false;
        },(error)=>{

        });
  }

  
  dateValTranform(dt)
  {
    return this.datePipe.transform(dt,"dd/MM/yyyy");
  }
}

@Component({
  selector: 'dialog-delete',
  templateUrl: "./confirm-dialog.html"
})
export class confirmDialog {

  showLoading=true;
  constructor(private dataPass:DataPassingService,public dialogRef: MatDialogRef<confirmDialog>,private api:ApiService,@Inject(MAT_DIALOG_DATA) public data: any) {
  
        
  }
  onOkClick(id){
     this.api.post({id:id},"removeDonar").subscribe(data=>{
      alert(data.message);
      window.location.reload();
    },(error)=>{});
  }
  onNoClick(): void {
    this.dialogRef.close();
  }

}